import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import { Link, withRouter } from 'react-router-dom'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import PropTypes from 'prop-types'
import StatusFilter, { statusFilterMethod } from '../../Sales/Orders/TableComponents/StatusFilter'

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 200,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/delivery/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  { Header: 'Order Type', accessor: 'orderType', width: 100, hideable: true, hideDefault: true },
  { Header: 'Sales Order', accessor: 'sales.code', width: 150, hideable: true, hideDefault: false },
  { Header: 'Company', accessor: 'company.fn', width: 200, hideable: true, hideDefault: true },
  { Header: 'Enquiry', accessor: 'enquiry.code', width: 150, hideable: true, hideDefault: false },
  {
    Header: 'Delivery Type',
    width: 120,
    accessor: 'delivery.type',
    hideable: true,
    hideDefault: false,
  },
  { Header: 'Title', accessor: 'title' },
  {
    Header: 'Date',
    accessor: 'date',
    width: 100,
    Cell: DateCell,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Delivery Address',
    width: 400,
    accessor: 'delivery.address.label',
    hideable: true,
    hideDefault: true,
  },
  { Header: 'LOCODE', width: 80, accessor: 'delivery.location' },
  { Header: 'Country', width: 150, accessor: 'delivery.country' },
  { Header: 'Delivery date', width: 150, accessor: 'delivery.date', Cell: DateCell },
  {
    Header: 'Status',
    accessor: 'status',
    width: 150,
    Cell: StatusCell,
    filterMethod: statusFilterMethod,
    Filter: StatusFilter,
  },
]

function DeliveryOrderList (props) {
  const { list, fetch, fetching, company, onChangeCompany, hideCompany, hideCreate } = props
  console.log({ props })
  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      CreateButton={() =>
        hideCreate !== true && (
          <Button
            type={'primary'}
            size="small"
            icon={'plus'}
            onClick={() => {
              props.history.push({
                pathname: `/purchasing/delivery/new/`,
              })
            }}>
            New
          </Button>
        )
      }
      columns={columns}
    />
  )
}

DeliveryOrderList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
DeliveryOrderList.defaultProps = {}

export default withRouter(DeliveryOrderList)
